import classes from "./ContentWrapper.module.css";

export default function ContentWrapper({ children }) {
  return (
    <main className={classes.container} id="custom-scroll-y">
      {children}
    </main>
  );
}
